import React, { useState, useEffect, useRef } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  SetAddressForm,
  SetTheStateGetListActions,
  SetAddressCreateForm,
  SetAddressEditForm,
  SetActiveTabs,
  setPreviousDataFetchActions,
  setIDverifycationanotherapidatasActions, ////id verification another get api list
  setAadharBackSideImageAsbase64, ////Back----Base---64
  setAadharBackSideFilesAs, ///backside files
  setTheAadharBack_counts,
  SetActionsBasicFormsDetails,
  setTHnUMBERSRESPONSES,
} from "../../../Redux/Slice";
import ReactCrop from "react-image-crop";
import "react-image-crop/dist/ReactCrop.css";
import Select from "react-select";
import { Button } from "@material-ui/core";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { useNavigate } from "react-router-dom";
import ImageCropper from "../ReactcropOverall/Imagecrop";
import { store } from "../../../Redux/Store";
import axios from "axios";
import { PresentUrl } from "../../../text/apidata";
import useDebouncedEffect from 'use-debounced-effect';
import { Downloads_doc } from "./Downloads_doc";

const AddressForm = () => {
  const stateDisplay = useSelector(
    (state) => state.SideBarActive.SidebarActive
  );
  const state = useSelector((state) => state);
  const [multiselect, setMuliselect] = useState([]);
  const [Permanatval, setPermanatval] = useState([]);
  const [timeline_id, setTimelineId] = useState();
  const [aadharbackerr ,  setaadharbackErr] = useState("")
  const navigator = useNavigate();
  useEffect(() => {
    if (state.BasicFormCreated.BasciFormCreate != undefined) {
      setTimelineId(state.BasicFormCreated.BasciFormCreate);
    }
    console.log(state.BasicFormCreated, "asaxasxas");
  }, [state.BasicFormCreated.BasciFormCreate]);
  const dispatch = useDispatch();
  const [editStateID, setEditStateId] = useState();
  const initialState = {
    street_name: "",
    town_name: "",
    city_name: "",
    state_name: "",
    pin_code: "",
    state_id: "",
    check: false,

    // "aadhar_back": "1.0000",
    // "aadhar_back_count": 1,
    // "aadhar_number": "912251212711"
    aadhar_number:state.idverfiyicationapidatas?.SecondAadharNumbers,
  };
  const [data, setDatas] = useState(initialState);
  const form_data = new FormData();
  const [streetErr, setstreeterr] = useState("");
  const [townErr, settwonerr] = useState("");
  const [cityErr, setcityerr] = useState("");
  const [stateErr, setstateerr] = useState("");
  const [pinErr, setpinerr] = useState("");

  const [streetErr1, setstreeterr1] = useState("");
  const [townErr1, settwonerr1] = useState("");
  const [cityErr1, setcityerr1] = useState("");
  const [stateErr1, setstateerr1] = useState("");
  const [pinErr1, setpinerr1] = useState("");
  const [profileFiles , setprofileIFile] = useState();

  const aadhaarformData = new FormData();

  const initialState1 = {
    street_name1: "",
    town_name1: "",
    city_name1: "",
    state_name1: "",
    pin_code1: "",
    state_id1: "",
  };

  const [permanent, setpermanent] = useState(initialState1);
  const [check, setCheck] = useState(false);
  let [nameList, setOptions] = useState([]);
  const [Checked, setCheckedValue] = useState([]);
  const initialStateSearch = {
    stateSearch: "",
  };
  const [SearchedVal, setSearched] = useState(initialStateSearch);
    
  const initialDebouanceSearch = {
    stateSearch: "",
};

const [SearchDebounance, setSearchDebounance] = useState(initialDebouanceSearch);
  ///-----Values----Fro----AddressState---
  const [PresenStaVal, setpresentValStEd] = useState();
  const [PermantStaVsl, setPermantValST] = useState();
  ////--------------Selected---IDS---Send---
  const [stateID, setstateId] = useState();
  const [PermantState, setPermanatState] = useState();

  ///---image---
  const [urlsign, setUrlsign] = useState();
  const [url_present, seturl_present] = useState(null);


  const [PresentUrlsAadhar , setpresenturlAadhar] = useState({
  aadhaarUrl:""
})
  const [addharsent, setAadharsent] = useState(false);


const [present_err , setpresent_err] = useState("")
  const [aadhaarFiles , setaadhaarFile] = useState();
const [forindex, setforindex] = useState();


  const [sendfile, seFiles] = useState(false);

  const [imgfile2, setimgfile2] = useState();

  const [imgsrc, setImgsrc] = useState();
  const imgRef = useRef(null);
  const [alert, setalert] = useState(false);
  const [CroppImageView, setCroppImageView] = useState(false);
  const muiltiplefiles = {
    file1: "",
    file2: "",
    file3: "",
  };
  const fileInputRef = useRef();

  const fileInputRef_present = useRef();

  ///---present---url
  const [PresentUrls , setPresentUrls] = useState([]);
  const [presenturlInUrl , seturlandfile] = useState({
    file:"",
    url:""  
    })

  const [count, setCount] = useState(0); // Initialize count with one_mark

  const incrementCount = () => {
    setCount(count + 1);
  };

  useEffect(() => {
    if (
      state.FormsIDList.BasicFormID != undefined &&
      state.FormsIDList.ActiveTabs == 2
    ) {
      let payload = {
        Retieveid: state.FormsIDList.BasicFormID,
      };
      dispatch(SetActionsBasicFormsDetails(payload));
    }
  }, [state.FormsIDList.ActiveTabs]);

  const [numberoffiles, setfiles] = useState(muiltiplefiles);
  const [CroppImageViewCount, setCroppImageViewCount] = useState(0);

  const fixedCropSize = { width: 300, height: 200 };

  const cancel2 = (e) => {
    setalert(true);
    setUrlsign("");
    setfiles({
      ...numberoffiles,
      file2: "",
    });
  };

  const HandleChanges = (e) => {
    setDatas((prev) => {
      return {
        ...prev,
        [e.target.name]: e.target.value.toUpperCase(),
      };
    });
  };

  const HandleChangesPermant = (e) => {
    if (e.target.name == "pin_code") {
      setpermanent((prev) => {
        return {
          ...prev,
          [e.target.name]: e.target.value.slice(0.6),
        };
      });
    } else {
      setpermanent((prev) => {
        return {
          ...prev,
          [e.target.name]: e.target.value.toUpperCase(),
        };
      });
    }
  };

    const handleFiles1 = (e) => {
    setCroppImageViewCount(1);
    setCroppImageView(true);
        setAadharsent(true);

    const file = e.target.files[0];
    setaadhaarFile(e);
    setforindex(1)
setpresent_err("")
    const allowedTypes = ["image/jpeg", "image/png", "image/svg+xml"];
    const maxSize = 10 * 1024 * 1024; // 3MB in bytes
    const MIN_DIMENSION = 150;
    if (file && allowedTypes.includes(file.type)) {
      if (file.size > maxSize) {
        setCroppImageView(false);
        toast.error("File size exceeds 10MB. Please upload a smaller image.");
      } else {
        const reader = new FileReader();
        reader.addEventListener("load", () => {
          const imageElement = new Image();
          const imageUrl = reader.result?.toString() || "";
          imageElement.src = imageUrl;
  
          imageElement.addEventListener("load", (imgEvent) => {
            const { naturalWidth, naturalHeight } = imgEvent.currentTarget;
  
            if (naturalWidth < MIN_DIMENSION || naturalHeight < MIN_DIMENSION) {
              toast.error("Image must be at least 150 x 150 pixels.");
              setCroppImageView(false);
              return;
            }
              selectedImage(e); // Continue processing the image
          });
        });
        reader.readAsDataURL(file); // Read the file as a data URL
      }
    } else {
      setCroppImageView(false);
      toast.error("Please upload an image file (jpg, jpeg, png, svg).");
      // e.target.value = ""; // Clear the file input
    }
    }
  //// aadhar chnages-----
  const handleFiles2 = (e) => {
    setPresentUrls([]);
    setCroppImageViewCount(2);
    setCroppImageView(true);
    seFiles(true);

    setalert(true);
    setaadharbackErr("")

    const file = e.target.files[0];
setforindex(0)
    const allowedTypes = ["image/jpeg", "image/png", "image/svg+xml"];
    const maxSize = 10 * 1024 * 1024; // 3MB in bytes
    const MIN_DIMENSION = 150;
    setprofileIFile(e)
    if (file && allowedTypes.includes(file.type)) {
      if (file.size > maxSize) {
        setCroppImageView(false);
        toast.error("File size exceeds 10MB. Please upload a smaller image.");
      } else {
        const reader = new FileReader();
        reader.addEventListener("load", () => {
          const imageElement = new Image();
          const imageUrl = reader.result?.toString() || "";
          imageElement.src = imageUrl;
  
          imageElement.addEventListener("load", (imgEvent) => {
            const { naturalWidth, naturalHeight } = imgEvent.currentTarget;
  
            if (naturalWidth < MIN_DIMENSION || naturalHeight < MIN_DIMENSION) {
              toast.error("Image must be at least 150 x 150 pixels.");
              setCroppImageView(false);
              return;
            }
              selectedImage(e); // Continue processing the image
          });
        });
        reader.readAsDataURL(file); // Read the file as a data URL
      }
    } else {
      setCroppImageView(false);
      toast.error("Please upload an image file (jpg, jpeg, png, svg).");
      // e.target.value = ""; // Clear the file input
    }

  };
  const updateAvatar = (imgSrc) => {
    // fileInputRef.current.value = imgSrc;
    
      if(CroppImageViewCount==1){ 
     fileInputRef_present.current.value = imgSrc;
 
      }
     else if (CroppImageViewCount == 2) {
     fileInputRef.current.value =imgSrc;
 
     }
  };
  const selectedImage = (e) => {
    console.log(e.target.files[0]);
    if (e.target.files && e.target.files.length > 0) {
      const reader = new FileReader();
      reader.addEventListener("load", () => setImgsrc(reader.result));
      reader.readAsDataURL(e.target.files[0]);
    }
  };

  const setCompletedCrop = async (c) => {
    const url = await getCroppedImg(imgRef.current, c, "newfile.jpeg");
  };
  const onImageLoaded = (image) => {
    // imgRef = image;
    imgRef.current = image;
  };

   
  function getCroppedImg(imageRef, crop, fileName) {  
    const canvas = document.createElement("canvas");
    const scaleX = imageRef.current.naturalWidth / imageRef.current.width;
    const scaleY = imageRef.current.naturalHeight / imageRef.current.height;
    canvas.width = crop.width * scaleX;
    canvas.height = crop.height * scaleY;
    const ctx = canvas.getContext("2d");
  
    ctx.drawImage(
        imageRef.current,
        crop.x * scaleX,
        crop.y * scaleY,
        crop.width * scaleX,
        crop.height * scaleY,
        0,
        0,
        crop.width * scaleX,
        crop.height * scaleY
    );
  
    
     return new Promise((resolve, reject) => {
       canvas.toBlob((blob) => {
         if (!blob) {
           console.error("Canvas is empty");
           return;
         }
         const croppedFile = new File([blob], fileName, {
           type: "image/jpeg",
         });
        //  setCroppImageView(false) 
        if(croppedFile){
          // setTimeout(() => {
            setCroppImageView(false)
      
          // }, 0);
         }
  
        var file = croppedFile;
          if (CroppImageViewCount == 1) {
            var reader = new FileReader();
            reader.onloadend = function () {
              seturl_present(reader.result);
            };
            reader.readAsDataURL(file);
   if(croppedFile){
    // setTimeout(() => {
      setCroppImageView(false)

    // }, 0);
    const generateRandomNumber = (digits = 12) => {
  const min = 10 ** (digits - 1);
  const max = 10 ** digits;
  return Math.floor(min + Math.random() * (max - min));
};


    
    const createPresentData = (croppedFile) => {
      const randomNumber = generateRandomNumber();
      const formattedFilename = `onboarding/${"present_address"}/${`present_address${randomNumber}`}.${croppedFile.type.split('/')[1]}`; // Use the file's extension
      const Presentdata = {
        multiple_files: [
          {
            filename: formattedFilename,
            file_type: croppedFile.type,
          },
        ],
      };
    
      return Presentdata;
    };
    
   
    
    const Presentdata = createPresentData(croppedFile); 
     
     
    axios( {
  url:PresentUrl,
  method:'post',
  data: Presentdata,
  headers: {
    Authorization:
      "Bearer " + store.getState().users.UserData.session.token,
  },
})
.then((response) => {
  console.log('Files uploaded successfully:', response.data);
  const uploadedFiles = response.data.data; // Adjust based on actual response structure
  console.log(uploadedFiles ,"uploadedFiles");
  
  const newUrls = uploadedFiles.map(file => ({
    url: file, // Adjust this based on the actual response
    type: croppedFile.type,
    putfiles:croppedFile
  }));

  setPresentUrls(prevUrls => {
    const updatedUrls = [...prevUrls];
    updatedUrls[forindex] = newUrls[0];
    return updatedUrls;
});  setpresenturlAadhar({
              aadhaarUrl:String(response.data.data).split("?")[0],
          
            })

})
.catch((error) => {
  console.error('Error uploading files:', error);
});




   }
 
 
          }

        else if (CroppImageViewCount == 2) {
          setfiles({
            ...numberoffiles,
            file2: croppedFile,
          });
  
          const generateRandomNumber = (digits = 12) => {
  const min = 10 ** (digits - 1);
  const max = 10 ** digits;
  return Math.floor(min + Math.random() * (max - min));
};

          
          const createPresentData = (croppedFile) => {
            const randomNumber = generateRandomNumber();
            const formattedFilename = `onboarding/aadharback/aadharback${randomNumber}.${croppedFile.type.split('/')[1]}`; // Use the file's extension
            const Presentdata = {
              multiple_files: [
                {
                  filename: formattedFilename,
                  file_type: croppedFile.type,
                },
              ],
            };
          
            return Presentdata;
          };
          
         
          
          const Presentdata = createPresentData(croppedFile);


          axios( {
            url:PresentUrl,
            method:'post',
            data: Presentdata,
            headers: {
              Authorization:
                "Bearer " + store.getState().users.UserData.session.token,
            },
          })
          .then((response) => {
            console.log('Files uploaded successfully:', response.data);
            const uploadedFiles = response.data.data; // Adjust based on actual response structure
            console.log(uploadedFiles ,"uploadedFiles");
            
            const newUrls = uploadedFiles.map(file => ({
              url: file, // Adjust this based on the actual response
              type: croppedFile.type,
              putfiles:croppedFile

            }));
          
            // Update PresentUrls state
 setPresentUrls(prevUrls => {
    const updatedUrls = [...prevUrls];
    updatedUrls[forindex] = newUrls[0];
    return updatedUrls;
});            seturlandfile({
              url: String(response.data.data).split("?")[0]
            })
          })
          .catch((error) => {
            console.error('Error uploading files:', error);
          });
        

          // console.log(croppedFile);
          setimgfile2(croppedFile);
          // console.log(croppedFile, "croppedFile");
          dispatch(setAadharBackSideFilesAs(croppedFile));
          var file = croppedFile;
          var reader = new FileReader();
          ////another ---api
  
          ///setIDverifycationanotherapidatasActions -------
          
          if (croppedFile) {
            aadhaarformData.append("aadhar_card", croppedFile);
            const payload = {
              fromdata: aadhaarformData,
              Imagetype: 2,
            };
            dispatch(setIDverifycationanotherapidatasActions(payload));
            incrementCount();
            dispatch(setTheAadharBack_counts(state.OnboardngCounts.aadhar_back_count + 1));
          }
       
       
          reader.onloadend = function () {
            setUrlsign(reader.result);
            var base64String = reader.result;
            var base64WithoutPrefix = base64String.replace(
              /^data:image\/(png|jpeg|jpg|gif);base64,/,
              ""
            );
  
            dispatch(setAadharBackSideImageAsbase64(reader.result));
          };
          reader.readAsDataURL(file);
  
          if (croppedFile) {
            aadhaarformData.append("aadhar_card", croppedFile);

          }
        }
        blob.name = fileName;
        setCroppImageView(false);
        let fileUrl = window.URL.createObjectURL(blob);
        console.log(fileUrl);
        resolve(fileUrl);
  
        // console.log(croppedFile       resolve(croppedFile);
       }, "image/jpeg");
     });
   }
  


  var State_NameIDs;


  ////---aadhar-----front---images---
  useEffect(() => {

    if (
      state.idverfiyicationapidatas.SecondAadharNumbers != "" &&
      state.idverfiyicationapidatas.AadharBackSideImageDatas != undefined &&
      state.idverfiyicationapidatas.AadharBackSideImageDatas != null &&
      state.idverfiyicationapidatas.AadharBackSideImageDatas != [] &&
      state.idverfiyicationapidatas.AadharBackSideImageDatas.address_details !=
        undefined &&
      state.idverfiyicationapidatas.AadharBackSideImageDatas.address_details !=
        null
    ) {
      state.OverallStateCallData.OverallStateGetList != undefined &&
        state.OverallStateCallData.OverallStateGetList != null &&
        state.idverfiyicationapidatas.AadharBackSideImageDatas.address_details.State != "" &&
        state.OverallStateCallData.OverallStateGetList.forEach((element) => {
          if (
            state.idverfiyicationapidatas.AadharBackSideImageDatas.address_details.State != "" &&
            element.state_name.toLowerCase().trim() ==
            state.idverfiyicationapidatas.AadharBackSideImageDatas.address_details.State.toLowerCase().trim()
          ) {
            State_NameIDs = element.id;
            console.log(element.id, "element.id");
            setPermantValST({ value: element.id, label: element.state_name })
            // setpresentValStEd({ value: element.id, label: element.state_name });
             if(check == true){
              setpresentValStEd({value: element.id, label: element.state_name})

             }
          }

          
        });

        if(state.idverfiyicationapidatas.AadharBackSideImageDatas.address_details.State ==""){

          setPermantValST({ value: "", label: "" });
          State_NameIDs = "";

          // setpresentValStEd({ value: element.id, label: element.state_name });
           if(check == true){
            setpresentValStEd({value: "", label: ""})

           }
        }
    }

    if (
      // state.idverfiyicationapidatas.FirstAadharNumber ==
      state.FormsIDList.BasicFormID !="" &&

      state.idverfiyicationapidatas.SecondAadharNumbers != "" &&
      urlsign &&
      state.idverfiyicationapidatas.AadharBackSideImageDatas != undefined &&
      state.idverfiyicationapidatas.AadharBackSideImageDatas != null &&
      state.idverfiyicationapidatas.AadharBackSideImageDatas != [] &&
      state.idverfiyicationapidatas.AadharBackSideImageDatas.address_details !=
        undefined &&
      state.idverfiyicationapidatas.AadharBackSideImageDatas.address_details !=
        null
    ) {
      // console.log(State_NameIDs, "State_NameIDs");

      // console.log(
      //   state.idverfiyicationapidatas.AadharBackSideImageDatas,
      //   "sdasd sdlsd"
      // );

      // setDatas({
      //   ...data,
      //   street_name:
      //     state.idverfiyicationapidatas.AadharBackSideImageDatas.address.toUpperCase(),
      //   town_name: "",
      //   city_name:
      //     state.idverfiyicationapidatas.AadharBackSideImageDatas.address_details.City.toUpperCase(),
      //   state_name:
      //     State_NameIDs != undefined && State_NameIDs != null
      //       ? State_NameIDs.toUpperCase()
      //       : "",
      //   pin_code:
      //     state.idverfiyicationapidatas.AadharBackSideImageDatas.address_details
      //       .PIN,
      //   state_id: State_NameIDs,
      // });
      // setcityerr1("");
      // setstreeterr1("");
      // setpinerr1("");
      // setpinerr("");
      // setaadharbackErr("")

      setpermanent({
        ...permanent,
        street_name1: state.idverfiyicationapidatas.AadharBackSideImageDatas.address.toUpperCase(),
        town_name1: "",
        city_name1: state.idverfiyicationapidatas.AadharBackSideImageDatas.address_details.City.toUpperCase(),
        pin_code1: state.idverfiyicationapidatas.AadharBackSideImageDatas.address_details
              .PIN,
        //state_name1: data.state_name.id,
        state_name1: State_NameIDs,
      });
      setstreeterr1("");
      setcityerr1("");
      setstateerr1("");
      settwonerr1("");
      setpinerr1("");
setDatas({
  ...data,
  aadhar_number:state.idverfiyicationapidatas?.SecondAadharNumbers
})
       if(check == true){
        setDatas({
          ...data,
          street_name: state.idverfiyicationapidatas.AadharBackSideImageDatas.address.toUpperCase(),
          town_name: "",
          city_name: state.idverfiyicationapidatas.AadharBackSideImageDatas.address_details.City.toUpperCase(),
          pin_code: state.idverfiyicationapidatas.AadharBackSideImageDatas.address_details
          .PIN,
          //state_name: state.AddressForms.AddressForm.state_name,
          state_name: State_NameIDs,
            aadhar_number: state.idverfiyicationapidatas?.SecondAadharNumbers,
      });
       }
    } else if (!urlsign) {
      // setDatas({
      //   ...data,
      //   street_name: "",
      //   town_name: "",
      //   city_name: "",
      //   state_name: "",
      //   pin_code: "",
      //   state_id: "",
      // });
      setpermanent({
        ...permanent,
        street_name1: "",
        town_name1: "",
        city_name1: "",
        pin_code1: "",
        state_name1: "",
      });
     
    }
    // else if (
    //   state.idverfiyicationapidatas.FirstAadharNumber !=
    //   state.idverfiyicationapidatas.SecondAadharNumbers
    // ) {
    //   toast.error(` ${"Please Upload Correct Aadhar Back Side Image"} `, {
    //     position: toast.POSITION.TOP_RIGHT,
    //   });

    //   navigator("/fieldagent")

    // }

    if (
      state.FormsSDETAILS.BasciForm.id != undefined &&
      state.FormsIDList.BasicFormID == state.FormsSDETAILS.BasciForm.id &&
      state.FormsIDList.BasicFormID != ""
    ) {
    }
  }, [state.idverfiyicationapidatas.AadharBackSideImageDatas]);

  useEffect(() => {
    if (
      state.FormsIDList.AddressId != "" &&
      state.FormsIDList.AddressId != undefined &&
      state.FormsIDList.ActiveTabs == 2
    ) {
      let payload = {
        Retieveid: state.FormsIDList.AddressId,
      };

      dispatch(SetAddressForm(payload));
    }
  }, [state.FormsIDList.ActiveTabs == 2]);

  // console.log(state.FormsIDList.AddressId, "employssdg", state.FormsIDList);

  useEffect(() => {
    if (
      state.FormsIDList.AddressId != "" &&
      state.AddressForms.AddressForm != undefined &&
      state.AddressForms.AddressForm != null &&
      state.AddressForms.AddressForm.id == state.FormsIDList.AddressId
    ) {
      // console.log(state.AddressForms.AddressForm, "AddressDetila");

      setDatas({
        ...data,
        street_name: state.AddressForms.AddressForm.street_name,
        town_name: state.AddressForms.AddressForm.town_name,
        city_name: state.AddressForms.AddressForm.city_name,
        pin_code: state.AddressForms.AddressForm.pin_code,
        //state_name: state.AddressForms.AddressForm.state_name,
        state_name: stateID,
      });
      setstreeterr("");

      setpinerr("");
      setcityerr("");


      if(
  // state.AddressForms.AddressForm.permanent_address == false &&
  state.AddressForms.AddressForm.present_address_supportDoc_id != null ){
          seturl_present(state.AddressForms.AddressForm.present_address_supportDoc_id.media_url);
                  setAadharsent(false)

        setpresenturlAadhar({
          ...PresentUrlsAadhar,
          aadhaarUrl:state.AddressForms.AddressForm.present_address_supportDoc_id.media_url
        })

}
else if(state.AddressForms.AddressForm.present_address_supportDoc_id == null){
   seturl_present(null);
                  setAadharsent(false)

        setpresenturlAadhar({
          ...PresentUrlsAadhar,
          aadhaarUrl:""
        })
}

      if (
        state.AddressForms.AddressForm.aadhar_back != undefined &&
        state.AddressForms.AddressForm.aadhar_back != null &&
        state.AddressForms.AddressForm.aadhar_back.media_url != undefined &&
        state.AddressForms.AddressForm.aadhar_back.media_url != null
      ) {
        setUrlsign(state.AddressForms.AddressForm.aadhar_back.media_url);
        seturlandfile({
          url: state.AddressForms.AddressForm.aadhar_back.media_url
        })
        seFiles(false);
        setaadharbackErr("");

      }

      if (
        state.AddressForms.AddressForm.finance_data != undefined &&
        state.AddressForms.AddressForm.finance_data != null &&
        state.AddressForms.AddressForm.finance_data[0]
      ) {
        dispatch(
          setTheAadharBack_counts(
            state.AddressForms.AddressForm.finance_data[0].aadhar_back_count
          )
        );
      }
      if (
        state.AddressForms.AddressForm.finance_data != undefined &&
        state.AddressForms.AddressForm.finance_data != null &&
        state.AddressForms.AddressForm.finance_data[0]
      ) {
        const round =
          state.AddressForms.AddressForm.finance_data[0].aadhar_back_count;
        setCount(Math.round(round));
      }
    }

    if (state.FormsIDList.AddressId == "") {
      dispatch(setTheAadharBack_counts(0));
    }

  }, [state.AddressForms.AddressForm, 
    // stateID,
     state.FormsIDList.AddressId]);
  useEffect(() => {
    if (
      state.FormsIDList.AddressId != "" &&
      state.AddressForms.AddressForm != undefined &&
      state.AddressForms.AddressForm != null &&
      state.AddressForms.AddressForm.id == state.FormsIDList.AddressId &&
      state.AddressForms.AddressForm != undefined &&
      state.AddressForms.AddressForm.state_name != null &&
      state.AddressForms.AddressForm.state_name != undefined
    ) {
      setstateId(state.AddressForms.AddressForm.state_name.id);
      if (
        state.FormsIDList.AddressId != "" &&
        state.AddressForms.AddressForm != undefined &&
        !state.AddressForms.AddressForm.permanent_address &&
        state.AddressForms.AddressForm.permanent_address_id != undefined &&
        state.FormsIDList.AddressId != "" &&
        state.AddressForms.AddressForm.id == state.FormsIDList.AddressId &&
        state.AddressForms.AddressForm.permanent_address_id.state_name !=
          undefined
      ) {
        // setPermanatState(
        //   state.AddressForms.AddressForm.permanent_address_id.state_name.id
        // );
      }
    }
  }, [state.AddressForms.AddressForm]);
  ///---Edit----State----Call----
 
  useEffect(() => {
    if (
      state.FormsIDList.AddressId != "" &&
      state.AddressForms.AddressForm != undefined &&
      state.AddressForms.AddressForm != null &&
      state.AddressForms.AddressForm.id == state.FormsIDList.AddressId &&
      state.AddressForms.AddressForm.state_name != undefined &&
      state.AddressForms.AddressForm.state_name != null
    ) {
      // console.log(state.AddressForms.AddressForm, "AddressDetila");
      let ObjectState = [];
      ObjectState.push({
        value: state.AddressForms.AddressForm.state_name.id,
        label: state.AddressForms.AddressForm.state_name.state_name,
      });

      setpresentValStEd(ObjectState);
    }

    if (
      state.EmployeeProfile.EmployeeProfileList != "" &&
      state.FormsIDList.AddressId != "" &&
      state.AddressForms.AddressForm != undefined &&
      state.AddressForms.AddressForm != null &&
      state.AddressForms.AddressForm.id == state.FormsIDList.AddressId &&
      state.AddressForms.AddressForm.permanent_address_id != undefined &&
      state.AddressForms.AddressForm.permanent_address_id.state_name !=
        undefined &&
      state.AddressForms.AddressForm.permanent_address_id.state_name != null
    ) {
      let ObjectState = [];
      ObjectState.push({
        value:
          state.AddressForms.AddressForm.permanent_address_id.state_name.id,
        label:
          state.AddressForms.AddressForm.permanent_address_id.state_name
            .state_name,
      });
      setPermanatState(
        state.AddressForms.AddressForm.permanent_address_id.state_name.id
      );

      setPermantValST(ObjectState);
      // console.log(
      //   state.AddressForms.AddressForm.permanent_address_id.state_name.id,
      //   "xdiywdxgiwyxdqiy"
      // );
    }
    if (
      state.FormsIDList.AddressId != "" &&
      state.EmployeeProfile.EmployeeProfileList != "" &&
      state.AddressForms.AddressForm.permanent_address &&
      state.AddressForms.AddressForm.state_name != undefined &&
      state.AddressForms.AddressForm.state_name != null &&
      state.AddressForms.AddressForm.state_name.id != undefined &&
      state.AddressForms.AddressForm.state_name.id != null
    ) {
      let ObjectStates = [];
      ObjectStates.push({
        value: state.AddressForms.AddressForm.state_name.id,
        label: state.AddressForms.AddressForm.state_name.state_name,
      });

      setPermantValST(ObjectStates);
    }
  }, [state.AddressForms.AddressForm]);

//  console.log(state.AddressForms.AddressForm,"qo73wiskdjn",state.FormsIDList.AddressId);

  // useEffect(() => {
  //   if (
  //     // state.FormsIDList.AddressId != "" &&
  //     // state.AddressForms.AddressForm != null &&
  //     // state.AddressForms.AddressForm != undefined &&
   
  //     // state.AddressForms.AddressForm.id == state.FormsIDList.AddressId.id &&
  //     //    !state.AddressForms.AddressForm.permanent_address &&
  //     // state.AddressForms.AddressForm.permanent_address_id != null
  //     state.FormsIDList.AddressId != "" &&
  //     state.AddressForms.AddressForm != undefined &&
  //     state.AddressForms.AddressForm != null &&
  //     state.AddressForms.AddressForm.id == state.FormsIDList.AddressId &&
  //     !state.AddressForms.AddressForm.permanent_address 

  //   ) {
  //           setCheck(state.AddressForms.AddressForm.permanent_address);

  //     setpermanent({
  //       ...permanent,
  //       street_name1:
  //         state.AddressForms.AddressForm.permanent_address_id.street_name,
  //       town_name1:
  //         state.AddressForms.AddressForm.permanent_address_id.town_name,
  //       city_name1:
  //         state.AddressForms.AddressForm.permanent_address_id.city_name,
  //       pin_code1:
  //       state.AddressForms.AddressForm.permanent_address_id.pin_code,
  //       //state_name1:
  //       //  state.AddressForms.AddressForm.permanent_address_id.state_name,
  //       state_name1: PermantState,
  //     });
  //     setcityerr1("");
  //     setstreeterr1("");
  //     setpinerr1("");
  //     setstateerr1("")
  //   } else if (
  //     // state.EmployeeProfile.EmployeeProfileList != "" &&
  //     // state.AddressForms.AddressForm != "" &&
  //     // state.AddressForms.AddressForm.permanent_address
  //     // &&

  //     state.FormsIDList.AddressId != "" &&
  //     state.AddressForms.AddressForm != undefined &&
  //     state.AddressForms.AddressForm.permanent_address &&
  //     state.AddressForms.AddressForm.id == state.FormsIDList.AddressId
  //   ) {

  //     //  dispatch(setTHnUMBERSRESPONSES())
  //     ////-------if----the---permanet ----address--id true----
  //     setpermanent({
  //       ...permanent,

  //       street_name1: state.AddressForms.AddressForm.street_name,
  //       town_name1: state.AddressForms.AddressForm.town_name,
  //       city_name1: state.AddressForms.AddressForm.city_name,
  //       pin_code1: state.AddressForms.AddressForm.pin_code,
  //       state_name1: state.AddressForms.AddressForm.state_name.id,
  //       // state_name1: stateID,
  //     });
  //     setPermantValST(PresenStaVal); //---the---present--address--have---to==be ---in----permant state
  //     ///-----------_The------Set-=----the-----same----address--is--true
  //     setCheck(state.AddressForms.AddressForm.permanent_address);
  //     // setpermanent({
  //     //   ...permanent,

  //     //   street_name1: "",
  //     //   town_name1: "",
  //     //   city_name1: "",
  //     //   pin_code1: "",
  //     //   // state_name1: state.AddressForms.AddressForm.state_name.id,
  //     //   state_name1: "",
  //     // });

  //     // console.log(permanent, "permanent");
  //   }
  //   else if (
  //     state.FormsIDList.AddressId != "" &&
  //     state.EmployeeProfile.EmployeeProfileList != "" &&
  //     state.AddressForms.AddressForm.permanent_address &&
  //     state.AddressForms.AddressForm.permanent_address_id == null
  //   ) {
  //     setpermanent({
  //       ...permanent,

  //       street_name1: state.AddressForms.AddressForm.street_name,
  //       town_name1: state.AddressForms.AddressForm.town_name,
  //       city_name1: state.AddressForms.AddressForm.city_name,
  //       pin_code1: state.AddressForms.AddressForm.pin_code,
  //       state_name1: state.AddressForms.AddressForm.state_name.id,
  //       // state_name1: stateID,
  //     });
  //     setcityerr1("");
  //     setstreeterr1("");
  //     setpinerr1("");
  //     setstateerr1("")

      
  //     setDatas({
  //       ...data,
  //       street_name: state.AddressForms.AddressForm.street_name,
  //       town_name: state.AddressForms.AddressForm.town_name,
  //       city_name: state.AddressForms.AddressForm.city_name,
  //       pin_code: state.AddressForms.AddressForm.pin_code,
  //       state_name: state.AddressForms.AddressForm.state_name?.id,
  //       // state_name: stateID,
  //     });
  //     setstreeterr("");
  //     setpinerr("");
  //     setcityerr("");


      
  //   }
  //   if (
  //     state.FormsIDList.AddressId != "" &&
  //     state.EmployeeProfile.EmployeeProfileList != "" &&
  //     state.AddressForms.AddressForm != undefined &&
  //     state.AddressForms.AddressForm.permanent_address
  //   ) {
  //     setCheck(state.AddressForms.AddressForm.permanent_address);
  //   }
  // }, [
  //   state.AddressForms.AddressForm,
  //   PermantState,
  //   state.FormsIDList.AddressId,
  //   state.FormsIDList.ActiveTabs,
  // ]);
   useEffect(() => {
    if (
      state.FormsIDList.AddressId != "" &&
      state.AddressForms.AddressForm != undefined &&
      state.AddressForms.AddressForm != null &&
      state.AddressForms.AddressForm.id == state.FormsIDList.AddressId 
      // &&
      // !state.AddressForms.AddressForm.permanent_address 

    ) {
            setCheck(state.AddressForms.AddressForm.permanent_address);
if(state.AddressForms.AddressForm.permanent_address == true){
let stateid  = state.AddressForms.AddressForm.state_name != null ? state.AddressForms.AddressForm.state_name?.id : "";
let stateid_object = state.AddressForms.AddressForm.state_name != null ? {label:state.AddressForms.AddressForm.state_name?.state_name,value:state.AddressForms.AddressForm.state_name?.id} : null

      ////-------if----the---permanet ----address--id true----
      setpermanent({
        ...permanent,

        street_name1: state.AddressForms.AddressForm.street_name,
        town_name1: state.AddressForms.AddressForm.town_name,
        city_name1: state.AddressForms.AddressForm.city_name,
        pin_code1: state.AddressForms.AddressForm.pin_code,
        state_name1: stateid,
        // state_name1: stateID,
      });
      console.log(stateid_object ,"stateid_object");
      
      setPermantValST(stateid_object); //---the---present--address--have---to==be ---in----permant state

      setcityerr1("");
      setstreeterr1("");
      setpinerr1("");
      setstateerr1("")

      
      setDatas({
        ...data,
        street_name: state.AddressForms.AddressForm.street_name,
        town_name: state.AddressForms.AddressForm.town_name,
        city_name: state.AddressForms.AddressForm.city_name,
        pin_code: state.AddressForms.AddressForm.pin_code,
        state_name: stateid,
        // state_name: stateID,
      });
      setstreeterr("");
      setpinerr("");
      setcityerr("");




    }
     else {
       
      setpermanent({
        ...permanent,
        street_name1:
          state.AddressForms.AddressForm.permanent_address_id.street_name,
        town_name1:
          state.AddressForms.AddressForm.permanent_address_id.town_name,
        city_name1:
          state.AddressForms.AddressForm.permanent_address_id.city_name,
        pin_code1:
        state.AddressForms.AddressForm.permanent_address_id.pin_code,
        //state_name1:
        //  state.AddressForms.AddressForm.permanent_address_id.state_name,
        state_name1: PermantState,
      });
      setcityerr1("");
      setstreeterr1("");
      setpinerr1("");
      setstateerr1("")
     }
    } 

  }, [
    state.AddressForms.AddressForm,
    PermantState,
    state.FormsIDList.AddressId,
    state.FormsIDList.ActiveTabs,
  ]);
  

  

  ///--------------State-----------------
  useEffect(() => {
    if (state.FormsIDList.ActiveTabs == 2) {
      const payloads = {
        search: SearchedVal.stateSearch,
        page_size: "",
        page: 1,
        is_reliever:"false"
      };
      dispatch(SetTheStateGetListActions(payloads));
    }
  }, [SearchedVal.stateSearch , state.FormsIDList.ActiveTabs]);
 
  useEffect(() => {
    const Datas = [];

    if (state.OverallStateCallData.OverallStateGetList != undefined) {
      let objectArray = [];
      state.OverallStateCallData.OverallStateGetList.forEach((element) => {
        objectArray.push({ value: element.id, label: element.state_name });
      });
      setOptions(objectArray);
    }
  }, [state.OverallStateCallData.OverallStateGetList, SearchedVal.stateSearch]);

  useDebouncedEffect(
    () => {
        if (setSearchDebounance) {
            setSearched({
                ...SearchedVal,
                stateSearch: SearchDebounance.stateSearch,
            });
        }
    },
    500,
    [SearchDebounance]
);

///-----State----Input Changes
 const handleInputChange = (Val) => {
  setSearchDebounance({
      ...SearchDebounance,
      stateSearch: Val,

  });

};
  const handleSelectChange = (selectedVal) => {
    // console.log(selectedVal, "valuesss");
    setpresentValStEd(selectedVal);
    setMuliselect(selectedVal);
    setCheckedValue(selectedVal);
    setpresentValStEd(selectedVal);
    setDatas({
      ...data,
      state_name: selectedVal.value,
      state_id: selectedVal.value,
    });
    setstateId(selectedVal.value);
  };

  const HandleChangesStatePermant = (selectedVal) => {
    setPermantValST(selectedVal);
      setpermanent({
        ...permanent,
  
        state_name1: selectedVal.value,
state_id1: selectedVal.value,
      });
     

  };
  const inputRef = useRef(null);
  const preventZoom = (event) => {
    if ((event.ctrlKey || event.metaKey) && (event.key === '+' || event.key === '-' || event.type === "wheel")) {
      event.preventDefault();
    }
  
    if (["e", "E", "+", "-", "."].includes(event.key) || event.key === 'ArrowUp' || event.key === 'ArrowDown') {
      event.preventDefault();
    }
  };
  // Validate the pasted content and strip invalid characters
 const handlePaste = (event) => {
  let paste = (event.clipboardData || window.clipboardData).getData('text');
  console.log(paste ,"934809paste");
  
  // Strip non-numeric characters (allow only digits)
  const filtered = paste.replace(/[^0-9]/g, '');
  
  // Prevent the default paste action and set the input value to the filtered result
  event.preventDefault();
  
  if (filtered.length <= 6) { // Ensure max length of 6 digits
    event.target.value = filtered;
     if(event.target.name == "pin_code1"){ 
    HandleChangesPermant({ target: { name: event.target.name, value: filtered } }); // Trigger onChange logic
     }
      else {
        HandleChanges({ target: { name: event.target.name, value: filtered } });

      }
  }
};

  
    useEffect(() => {
           const inputElement = inputRef.current;
      if (inputElement) {
        inputElement.addEventListener('wheel', preventZoom);
      }
      // Cleanup to remove the event listener when the component unmounts
      return () => {
        if (inputElement) {
          inputElement.removeEventListener('wheel', preventZoom);
        }
      };
    }, []);
  
  
       console.log(sendfile ,"sendfile",PresentUrlsAadhar.aadhaarUrl , url_present ,urlsign , data , permanent);


  const HandleNext = () => {
    var addressForm = state.AddressForms.AddressForm || {};
    var permanentAddress = addressForm.permanent_address_id || {};
    const fetchUploadFiles = async () => {       
      await Promise.all(PresentUrls.map(async (item) => {      
        try {
                  if(item != undefined && item != null){ 

          const response = await fetch(item.url, {
            method: 'PUT',
            headers: {
              'Content-Type': item.type,
              "x-amz-acl":"public-read"
            },
            body: item.putfiles,
          });
      
              // setUrlsign(presenturlInUrl.url);
              setUrlsign(presenturlInUrl?.url)
                          seturl_present(PresentUrlsAadhar.aadhaarUrl);

              // setPresentUrls([]);
// if(state.FormsIDList.AddressId == ""){
//   const payload = {
//     permanent: permanent,
//     data: data,
//     check: check,
//     timeline_id: state.BasicFormCreated.BasciFormCreate,
//     form_data: AddressData,
//   };
//   dispatch(SetAddressCreateForm(payload));

// }
//  else if(    state.AddressForms.AddressForm != null &&
//   state.FormsIDList.AddressId != "" 
// ){
//   const payload = {
//     permanent: permanent,
//     check: check,
//     data: data,
//     id: state.FormsIDList.AddressId,
//     // timeline_id: state.BasicFormCreated.BasciFormCreate,
//     timeline_id:
//       state.BasicFormCreated.BasciFormCreate == ""
//         ? state.EmployeeProfile.EmployeeProfileList.id
//         : state.BasicFormCreated.BasciFormCreate,

//     form_data: AddressData,
//   };
//   dispatch(SetAddressEditForm(payload));

//  }

        }

        } catch (error) {
          console.error('Error uploading files:', error);
        }
      }));
    };
   let AddressData ={
    present_address: {
      street_name: data.street_name != "" && data.street_name,
      town_name: data.town_name != "" && data.town_name != undefined ? data.town_name.trim() : " ",
      city_name: data.city_name != "" && data.city_name,
      state_name:data.state_name != undefined &&  data.state_name != "" ? data.state_name : "",
      pin_code: data.pin_code,
    },
    permanent_address: {
      street_name:
        permanent.street_name1 != "" && permanent.street_name1,
      town_name:
        permanent.town_name1 != "" ? permanent.town_name1 : "",
      city_name: permanent.city_name1 != "" && permanent.city_name1,
      state_name:
        permanent.state_name1 != "" && permanent.state_name1,
      pin_code: permanent.pin_code1,
    },
    is_permanent: check,
    present_address_supportDoc_id:PresentUrlsAadhar?.aadhaarUrl =="" || PresentUrlsAadhar?.aadhaarUrl == null ? null : PresentUrlsAadhar?.aadhaarUrl,
    timeline_id:
      state.BasicFormCreated.BasciFormCreate == ""
        ? state.EmployeeProfile.EmployeeProfileList.id
        : state.BasicFormCreated.BasciFormCreate,

    aadhar_back_count: state.OnboardngCounts.aadhar_back_count,
    aadhar_number: data.aadhar_number,
    aadhar_back:presenturlInUrl.url
   }
    
 

    if (sendfile) {
      form_data.append("aadhar_back", imgfile2);
    }

    
    var a = 0;
    if (state.FormsIDList.AddressId == "") {



      // if(state.NumberCounts.Editable != 1){ 
      if (data.street_name == "") {
        setstreeterr("*Street  is required");
        a = 1;
      }

      if(check == false){
        if(url_present =="" || !url_present){
                  a = 1;
        setpresent_err("Present Address Document is required")
        }
      }
      //  if(!sendfile){
        if(urlsign == undefined || urlsign == null || urlsign == ""){ 

 a = 1;
        setaadharbackErr("*Aadhaar Backside Image is required")

       }
      // if (data.state_id == "") {
      //   setstateerr("*State name is required");
      //   a = 1;
      // }
      if (data.city_name == "") {
        setcityerr("*City  is required");
        a = 1;
      }
      if (data.pin_code == "") {
        setpinerr("*Pin code is required");
        a = 1;
      }
      if ( data.pin_code != "" && data.pin_code.length > 6) {
        setpinerr("*Pin code should not exit more than 6 numbers");
        a = 1;
      }
      // if (data.town_name == "") {
      //   settwonerr("*Town name is required");
      //   a = 1;
      // }
      if (permanent.city_name1 == undefined || permanent.city_name1 == "") {
        setcityerr1("*City name is required");
        a = 1;
      }

      if (permanent.street_name1 == "") {
        setstreeterr1("*street  is required");
        a = 1;
      }

      if (permanent.pin_code1 == "") {
        setpinerr1("*Pin code is required");
        a = 1;
      }
      if (permanent.pin_code1 != "") {
        if (permanent.pin_code1.length > 6) {
          setpinerr1("*Pin code should not exit more than 6 numbers");
          a = 1;
        }
      }

      // if (permanent.town_name1 == "") {
      //   settwonerr1("*Town name is required");
      //   a = 1;
      // }

      if (permanent.state_name1 == ""|| permanent.state_name1 == undefined || permanent.state_name1 == null) {
        setstateerr1("*State  is required");
        a = 1;
      }
      if (data.state_name == ""|| data.state_name == undefined || data.state_name == null) {
        setstateerr("*State  is required");
        a = 1;
      }

    // }

    if( a == 0 && ( sendfile == true || addharsent == true)){
      fetchUploadFiles();

     }


      if (a == 0 ) {

        const payload = {
          permanent: permanent,
          data: data,
          check: check,
          timeline_id: state.BasicFormCreated.BasciFormCreate,
          form_data: AddressData,
        };
        dispatch(SetAddressCreateForm(payload));
      }
    } else if (
state.FormsIDList.AddressId != "" &&
state.AddressForms.AddressForm != null
  )

    {

     if(check == false){
        if(url_present ==""||!url_present){
                  a = 1;
        setpresent_err("Present Address Document is required")
        }
      }
      if (data.street_name == "") {
        setstreeterr("*Street name is required");
        a = 1;
      }
      // if(!sendfile){
        if(urlsign == undefined || urlsign == null || urlsign == ""){ 

        a = 1;
               setaadharbackErr("*Aadhaar Backside Image is required")
       
              }
       
      if (data.state_name == ""|| data.state_name == undefined || data.state_name == null) {
        setstateerr("*State  is required");
        a = 1;
      }
      if (data.city_name == "") {
        setcityerr("*City  is required");
        a = 1;
      }
      if (data.pin_code == "") {
        setpinerr("*Pin code is required");
        a = 1;
      }

      if (permanent.city_name1 == undefined || permanent.city_name1 == "") {
        setcityerr1("*City  is required");
        a = 1;
      }




      if (permanent.street_name1 == undefined) {
        setstreeterr1("*street  is required");
        a = 1;
      }

      if (permanent.street_name1 == "") {
        setstreeterr1("*Street  is required");
        a = 1;
      }
      if (permanent.pin_code1 == undefined) {
        setpinerr1("*Pin code is required");
        a = 1;
      }
      if (permanent.pin_code1 == "") {
        setpinerr1("*Pin code is required");
        a = 1;
      }


      if (permanent.state_name1 == undefined || permanent.state_name1 == "") {
        setstateerr1("*State  is required");
        a = 1;
      }
    if( a == 0 && ( sendfile == true || addharsent == true)){
        fetchUploadFiles();
       }
       
if(
  a == 0 && 
  state.AddressForms.AddressForm != null &&
  state.FormsIDList.AddressId !== "" &&
  urlsign && // ✅ always holds a valid value
  (
    (
      check !== state.AddressForms.AddressForm.permanent_address &&
      (
        !check ? url_present != "" && !url_present : true // ✅ if check is false, url_present must not be empty
      )
    ) ||
    urlsign !== state.AddressForms.AddressForm?.aadhar_back?.media_url ||
    data.city_name !== addressForm.city_name ||
    data.pin_code !== addressForm.pin_code ||
    data.state_name !== stateID ||
    data.town_name !== addressForm.town_name ||
    data.street_name !== addressForm.street_name ||
    (
      addressForm.permanent_address_id == null &&
      (
        data.city_name !== permanent.city_name1 ||
        data.pin_code !== permanent.pin_code1 ||
        data.state_name !== permanent.state_name1 ||
        data.town_name !== permanent.town_name1
      )
    ) ||
    (
      addressForm.permanent_address_id != null &&
      (
        permanent.town_name1 !== permanentAddress.town_name ||
        permanent.pin_code1 !== permanentAddress.pin_code ||
        permanent.state_name1 !== PermantState ||
        permanent.street_name1 !== permanentAddress.street_name
      )
    ) ||
    sendfile === true || addharsent == true)){


      if (a == 0 ) {
        const payload = {
          permanent: permanent,
          check: check,
          data: data,
          id: state.FormsIDList.AddressId,
          // timeline_id: state.BasicFormCreated.BasciFormCreate,
          timeline_id:
            state.BasicFormCreated.BasciFormCreate == ""
              ? state.EmployeeProfile.EmployeeProfileList.id
              : state.BasicFormCreated.BasciFormCreate,

          form_data: AddressData,
        };
        dispatch(SetAddressEditForm(payload));
      }

    }
    else if( a == 0 
    ){
      if( urlsign && // ensure urlsign always has a value
  sendfile == false && // sendfile must be false
  addharsent == false &&
    (
      check === state.AddressForms.AddressForm.permanent_address &&
      !check &&
      url_present != "" &&
      url_present != null && 
      data.city_name === addressForm.city_name &&
      data.pin_code === addressForm.pin_code &&
      data.state_name === stateID &&
      data.town_name === addressForm.town_name &&
      data.street_name === addressForm.street_name
    ) ||
    (
      addressForm.permanent_address_id === null &&
      data.city_name === permanent.city_name1 &&
      data.pin_code === permanent.pin_code1 &&
      data.state_name === permanent.state_name1 &&
      data.town_name === permanent.town_name1
    ) ||
    (
      addressForm.permanent_address_id !== null &&
      permanent.town_name1 === permanentAddress.town_name &&
      permanent.pin_code1 === permanentAddress.pin_code &&
      permanent.state_name1 === PermantState &&
      permanent.street_name1 === permanentAddress.street_name
    )){

      dispatch(SetActiveTabs(10));
    }
    }
    } ///--------if--the--check is--true-----have to ---check---the----
    
    // else if (
      // check == state.AddressForms.AddressForm.permanent_address &&
      // urlsign == state.AddressForms.AddressForm?.aadhar_back?.media_url &&
      // !check && url_present !="" &&
      // (
      //   data.city_name == addressForm.city_name &&
      //   data.pin_code == addressForm.pin_code &&
      //   data.state_name == stateID &&
      //   data.town_name == addressForm.town_name &&
      //   data.street_name == addressForm.street_name 
  
      // ) || 
      // (
      //   addressForm.permanent_address_id == null &&
      //   (
      //     data.city_name == permanent.city_name1 &&
      //     data.pin_code == permanent.pin_code1 &&
      //     data.state_name == permanent.state_name1 &&
      //     data.town_name == permanent.town_name1
      //   )
      // ) || 
      // (
      //   addressForm.permanent_address_id != null &&
      //   (
      //     permanent.town_name1 == permanentAddress.town_name &&
      //     permanent.pin_code1 == permanentAddress.pin_code &&
      //     permanent.state_name1 == PermantState &&
      //     permanent.street_name1 == permanentAddress.street_name
      //   )
      // )&& sendfile == false
  //       urlsign && // ensure urlsign always has a value
  // sendfile === false && // sendfile must be false
  // (
  //   (
  //     check === state.AddressForms.AddressForm.permanent_address &&
  //     !check &&
  //     url_present != "" &&
  //     url_present != null && 
  //     data.city_name === addressForm.city_name &&
  //     data.pin_code === addressForm.pin_code &&
  //     data.state_name === stateID &&
  //     data.town_name === addressForm.town_name &&
  //     data.street_name === addressForm.street_name
  //   ) ||
  //   (
  //     addressForm.permanent_address_id === null &&
  //     data.city_name === permanent.city_name1 &&
  //     data.pin_code === permanent.pin_code1 &&
  //     data.state_name === permanent.state_name1 &&
  //     data.town_name === permanent.town_name1
  //   ) ||
  //   (
  //     addressForm.permanent_address_id !== null &&
  //     permanent.town_name1 === permanentAddress.town_name &&
  //     permanent.pin_code1 === permanentAddress.pin_code &&
  //     permanent.state_name1 === PermantState &&
  //     permanent.street_name1 === permanentAddress.street_name
  //   )
  // )

  //   ) {
  //     // console.log("Next ACTIVE");

  //     dispatch(SetActiveTabs(10));
  //   }
  };

console.log(urlsign ,"urlsign");

  return (
    <>
      <div className="">
        <div
        >
          <div className=" BodyContent">
            <div className="card">
              <div className="card-body cards ">
                <div className="UserPoup">
                  <div className="BeforForms">
                    <div className="Form">
                      <div className="ModalHeader">
                        <div>
                          <span>Address Details</span>
                        </div>
                      </div>

                      <div className="Modal-Body ModalForms">
                        <div className="row">
                          <div className="col-6">
                            <div>
                              <small style={{ color: "red" }}>
                                Note:Upload the Aadhaar Back picture, please.
                                 Verify that the file is in the JPG, JPEG, or 
                                 PNG format and that its size is less than 10 MB.
                              </small>
                            </div>

                            <div class="col-6 mt-3">
                                                          <>
                              <label
                                style={{
                                  margin: 0,
                                  padding: 10,
                                  width: "100%",
                                  display: "block",
                                }}
                                className="form-label"
                              >
                                Aadhaar Backside image
                          <span style={{ color: "red" }}>*</span>
                              </label>
                            </>

                              <>
                                {urlsign ? (
                                  <img
                                    src={urlsign}
                                    onClick={(e) => {
                                      if(state.NumberCounts.Editable == 1){ 

                                      window.open(urlsign);
                                      }
                                    }}
                                    
                                    className="pointer"
                                    style={{
                                      height: "153px",
                                      width: "198px",
                                      margin: "13px 25px 21px 0px",

                                      border: "4px solid #234492",
                                  borderRadius:"12px",

                                      marginRight: "25",
                                    }}
                                    alt="Image"
                                  />
                                ) : (

                                  <></>
                                )}

                                {!urlsign ? (
                                  <Button
                                    className="  doctorupload"
                                    variant="contained"
                                    component="label"
                                    style={{
                                      background: "#234492",
                                      color: "white",
                                      fontSize:"11px !important",
                                    }}
                                    disabled={
                                      state.NumberCounts.Editable == 1 &&
                                      state.ClientBranchIDs.SUBROLE != 3
                                        ? true
                                        : false
                                    }
                                  >
                                    <input
                                      type="file"
                                      hidden
                                      accept="image/png, image/jpeg"
                                      onChange={(e) => handleFiles2(e)}
                                      ref={fileInputRef}
                                    />
                                    Upload Image
                                  </Button>
                                ) : (
                                  <></>
                                )}

                                {urlsign ? (
                                                                                                  <div className="w-100 d-flex " style={{gap:"12px", flexDirection:"column"}}>

                                  <Button
                                    className="btn remove doctorupload"
                                    variant="contained"
                                    onClick={(e) => cancel2(e)}
                                    style={{
                                      background: "#234492",
                                      color: "white",
                                      fontSize:"11px !important",
width:"fit-content"

                                    }}
                                    disabled={
                                      state.NumberCounts.Editable == 1 &&
                                      state.ClientBranchIDs.SUBROLE != 3
                                        ? true
                                        : false
                                    }
                                  >
                                    Remove Image
                                  </Button>
                                  <Downloads_doc url={urlsign} />  
                                
                                  </div>
                                ) : (
                                  ""
                                )}
                              </>
                                                          <p className="Error" style={{ marginLeft: "-5px" , marginTop:"12px" }}>{aadharbackerr}</p>

                            </div>
                          </div>
                          <div className="col-6">
                        
                            <>
                              <label
                                style={{
                                  marginTop: "50px",
                                  padding: 10,
                                  width: "100%",
                                  display: "block",
                                }}
                                className="form-label"
                              >
                                Present Address Image
                         {
                          !check && (
                             <span style={{ color: "red" }}>*</span>
                          )
                         }
                              </label>
                            </>

                            <div class="col-6 mt-3">
                              <>
                                {url_present ? (
                                  <img
                                    src={url_present}
                                    onClick={(e) => {
                                      if(state.NumberCounts.Editable == 1){ 
                                      window.open(url_present);
                                      }
                                    }}
                                    
                                    className="pointer"
                                    style={{
                                      height: "153px",
                                      width: "198px",
                                      margin: "13px 25px 21px 0px",

                                      border: "4px solid #234492",
                                  borderRadius:"12px",

                                      marginRight: "25",
                                    }}
                                    alt="Image"
                                  />
                                ) : (

                                  <></>
                                )}

                                {!url_present ? (
                                  <Button
                                    className="  doctorupload"
                                    variant="contained"
                                    component="label"
                                    style={{
                                      background: "#234492",
                                      color: "white",
                                      fontSize:"11px !important",

                                    }}
                                    disabled={
                                      state.NumberCounts.Editable == 1 &&
                                      state.ClientBranchIDs.SUBROLE != 3
                                        ? true
                                        : false
                                    }
                                  >
                                    <input
                                      type="file"
                                      hidden
                                      accept="image/png, image/jpeg"
                                      onChange={(e) => handleFiles1(e)}
                                      ref={fileInputRef_present}
                                    />
                                    Upload Image
                                  </Button>
                                ) : (
                                  <></>
                                )}

                                {url_present ? (
                                <div className="w-100 d-flex " style={{gap:"12px", flexDirection:"column"}}>

                                  <Button
                                    className="btn remove doctorupload"
                                    variant="contained"
                                    onClick={(e) => {
                                      seturl_present("");
                                setAadharsent(false);
                                    }}
                                    style={{
                                      background: "#234492",
                                      color: "white",
                                      fontSize:"11px !important",
                                                                            width:"fit-content"

                                    }}
                                    disabled={
                                      state.NumberCounts.Editable == 1 &&
                                      state.ClientBranchIDs.SUBROLE != 3
                                        ? true
                                        : false
                                    }
                                  >
                                    Remove Image
                                  </Button>
                               <Downloads_doc url={url_present} />  

</div>
                                ) : (
                                  ""
                                )}
                              </>
                            </div>
                            <p className="Error" style={{ marginLeft: "-5px" , marginTop:"12px" }}>{present_err}</p>
                          </div>

                        </div>

                     

                        <>
                          <div className="row">
                            <div
                              className="col-12"
                              style={{ marginTop: "30px" }}
                            >
                              <label
                                className="form-label-Header"
                                style={{ fontWeight: "900" }}
                              >
                                Permanent address
                              </label>
                            </div>
                            <div className="col-sm-3 mt-3">
                              <label
                                for="validationCustom01"
                                class="form-label"
                              >
                                Street name
                              </label>
                              <span style={{ color: "red" }}>*</span>



                              <textarea
                                type="text"
                                class="form-control"
                                id="validationCustom01"
                                autocomplete="off"
                                name="street_name1"
                                readOnly={
                                  state.NumberCounts.Editable == 1 &&
                                  state.ClientBranchIDs.SUBROLE != 3
                                    ? true
                                    : false
                                }
                                onChange={(e) => {
                                  HandleChangesPermant(e);
                                  setstreeterr1("");
                                }}
                                value={permanent.street_name1}
                                disabled={
                                  state.NumberCounts.Editable == 1 &&
                                  state.ClientBranchIDs.SUBROLE != 3
                                    ? true
                                    : false
                                }
                              />
                              <p
                                className="Error"
                                style={{ marginLeft: "-5px" }}
                              >
                                {streetErr1}
                              </p>
                            </div>
                            <div className="col-sm-3 mt-3">
                              <label
                                for="validationCustom01"
                                class="form-label"
                              >
                                Town
                              </label>
                              <input
                                type="text"
                                class="form-control"
                                id="validationCustom01"
                                autocomplete="off"
                                name="town_name1"
                                readOnly={
                                  state.NumberCounts.Editable == 1 &&
                                  state.ClientBranchIDs.SUBROLE != 3
                                    ? true
                                    : false
                                }
                                onChange={(e) => {
                                  HandleChangesPermant(e);
                                  settwonerr1("");
                                }}
                                value={permanent.town_name1}
                                disabled={
                                  state.NumberCounts.Editable == 1 &&
                                  state.ClientBranchIDs.SUBROLE != 3
                                    ? true
                                    : false
                                }
                              />
                              {/* <p
                                className="Error"
                                style={{ marginLeft: "-5px" }}
                              >
                                {townErr1}
                              </p> */}
                            </div>

                            <div className="col-sm-3 mt-3">
                              <label
                                for="validationCustom01"
                                class="form-label"
                              >
                                City
                              </label>
                              <span style={{ color: "red" }}>*</span>

                              <input
                                type="text"
                                class="form-control"
                                id="validationCustom01"
                                autocomplete="off"
                                readOnly={
                                  state.NumberCounts.Editable == 1 &&
                                  state.ClientBranchIDs.SUBROLE != 3
                                    ? true
                                    : false
                                }
                                onChange={(e) => {
                                  HandleChangesPermant(e);
                                  setcityerr1("");
                                }}
                                name="city_name1"
                                value={permanent.city_name1}
                                disabled={
                                  state.NumberCounts.Editable == 1 &&
                                  state.ClientBranchIDs.SUBROLE != 3
                                    ? true
                                    : false
                                }
                              />

                              <p
                                className="Error"
                                style={{ marginLeft: "-5px" }}
                              >
                                {cityErr1}
                              </p>
                            </div>
                            <div
                              className="col-sm-3 mt-3"
                            >
                              <label
                                for="validationCustom0State Name1"
                                class="form-label"
                              >
                                State 
                              </label>
                              <span style={{ color: "red" }}>*</span>


                              <Select
                                className="Selects stateNames"
                                styles={{ position: "relative", top: "60px" }}
                                onChange={(e) => {
                                  HandleChangesStatePermant(e);
                                  setstateerr1("");

                                }}
                                onInputChange={handleInputChange}
                                options={nameList}
                                labelledBy="Select"
                                value={PermantStaVsl}
                                isDisabled={
                                  state.NumberCounts.Editable == 1 &&
                                  state.ClientBranchIDs.SUBROLE != 3
                                    ? true
                                    : false
                                }
                              />
                              <p
                                className="Error"
                                style={{ marginLeft: "-5px" }}
                              >
                                {stateErr1}
                              </p>
                            </div>
                          </div>
                          <div className="row PINCODE">
                      
                            <div
                              className="col-md-3"
                              style={{ marginTop: "69px" }}
                            >
                              <label
                                for="validationCustom01"
                                class="form-label"
                              >
                                Pincode 
                              </label>
                              <span style={{ color: "red" }}>*</span>

                              <input
                                type="number"
                                class="form-control"
                                id="validationCustom01"
                                autocomplete="off"
                                name="pin_code1"
                                ref={inputRef}

                                readOnly={
                                  state.NumberCounts.Editable == 1 &&
                                  state.ClientBranchIDs.SUBROLE != 3
                                    ? true
                                    : false
                                }
                                step="1"

                                onKeyDown={preventZoom}  // Prevent zoom and unwanted keys
                                onPaste={handlePaste}    // Handle pasting
                                onWheel={preventZoom}    // Prevent zooming with the mouse wheel
                              
                             
                                // onChange={(e) => {
                                //   HandleChangesPermant(e);
                                //   setpinerr1("");
                                // }}
                                onChange={(e) => {
                                  const value = e.target.value;
                            
                                  const phoneRegex = /^[1-9][0-9]{0,6}$/;
                                  setpinerr1("");
                                  if (value.length <= 6 && (phoneRegex.test(value) || value === '')) {
                                    HandleChangesPermant(e);
                                  }
                                }}
                                value={
                                  permanent.pin_code1
                                }
                                disabled={
                                  state.NumberCounts.Editable == 1 &&
                                  state.ClientBranchIDs.SUBROLE != 3
                                    ? true
                                    : false
                                }
                              />
                              <p
                                className="Error"
                                style={{ marginLeft: "-5px" }}
                              >
                                {pinErr1}
                              </p>
                            </div>
                          </div>


<div className="row">
<div className="col-6">
  
  </div>
                            <div
                                className="col-6"
                                style={{ marginTop: "30px" }}
                              >
                                <>
                                  <input
                                    class="form-check-input"
                                    type="checkbox"
                                    value={check}
                                    id="flexCheckChecked"
                                    readOnly={
                                      state.NumberCounts.Editable == 1
                                        ? true
                                        : false
                                    }
                                    checked={
  
                                      check
                                    }
                                    onChange={(e) => {
                                      setCheck(!check);
                                      if (!check) {
                                        setpresentValStEd(PermantStaVsl)

                                       setDatas({
                                         ...data,
                                         street_name:
                                           permanent.street_name1,
                                         town_name:permanent.town_name1,
                                         city_name:
                                           permanent.city_name1,
                                         state_name:permanent.state_name1,
                                         pin_code:
                                           permanent.pin_code1,
                                         state_id: permanent.state_name1,
                                       });

                                       setstreeterr("");
                                       setcityerr("");
                                       setpinerr("");
                                       setstateerr("");


                                      } else if (check) {
                                       setDatas({
                                        ...data,
                                        street_name:
                                          "",
                                        town_name:"",
                                        city_name:
                                          "",
                                        state_name:"",
                                        pin_code:
                                          "",
                                        state_id: "",
                                      });
                                      setpresentValStEd("")

                                      }
                                    }}
                                    disabled={
                                      state.NumberCounts.Editable == 1 &&
                                      state.ClientBranchIDs.SUBROLE != 3
                                        ? true
                                        : false
                                    }
                                  />
  
                                  <p>Same as Permanent address </p>
                                </>
                          
                              </div>
  
</div>

                        </>

                        <div className="col-12 mt-3" style={{marginLeft:"-8px"}}>
                            <label
                              for="validationCustom01"
                              class="form-label-Header"
                              style={{ fontWeight: "900" }}
                            >
                              Present address
                            </label>
                          </div>
<div className="row">
<div className="col-sm-3 mt-3">
                            <label for="validationCustom01" class="form-label">
                              Street name
                            </label>

<span style={{ color: "red" }}>*</span>

                            <textarea
                              type="text"
                              class="form-control"
                              id="validationCustom01"
                              autocomplete="off"
                              name="street_name"
                              readOnly={
                                state.NumberCounts.Editable == 1 &&
                                check == true
                                  ? true
                                  :check != true && state.ClientBranchIDs.SUBROLE == 3 ?
                                  false :
                                  check == true ?
                                   true
                                   : false
                              }
                              onChange={(e) => {
                                HandleChanges(e);
                                setstreeterr("");
                              }}
                              disabled={
                           
                                state.NumberCounts.Editable == 1 &&
                                check == true
                                  ? true
                                  :check != true && state.ClientBranchIDs.SUBROLE == 3 ?
                                  false :
                                  check == true ?
                                   true
                                   : false

                              }
                              value={data.street_name}
                            />

                            <p className="Error" style={{ marginLeft: "-5px"  }}>
                              {streetErr}
                            </p>
                          </div>

                          <div className="col-sm-3 mt-3">
                            <label for="validationCustom01" class="form-label">
                              Town
                            </label>

                            <input
                              type="text"
                              class="form-control"
                              id="validationCustom01"
                              autocomplete="off"
                              name="town_name"
                              readOnly={
                                state.NumberCounts.Editable == 1 &&
                                check == true
                                  ? true
                                  :check != true && state.ClientBranchIDs.SUBROLE == 3 ?
                                  false :
                                  check == true ?
                                   true
                                   : false

                              }
                              disabled={
                                state.NumberCounts.Editable == 1 &&
                                check == true
                                  ? true
                                  :check != true && state.ClientBranchIDs.SUBROLE == 3 ?
                                  false :
                                  check == true ?
                                   true
                                   : false



                              }
                              onChange={(e) => {
                                HandleChanges(e);
                                settwonerr("");
                              }}
                              value={data.town_name}
                            />
                      
                          </div>

                          <div className="col-sm-3 mt-3">
                            <label for="validationCustom01" class="form-label">
                              City
                            </label>
                            <span style={{ color: "red" }}>*</span>

                            <input
                              type="text"
                              class="form-control"
                              id="validationCustom01"
                              autocomplete="off"
                              name="city_name"
                              disabled={
                                state.NumberCounts.Editable == 1 &&
                                check == true
                                  ? true
                                  :check != true && state.ClientBranchIDs.SUBROLE == 3 ?
                                  false :
                                  check == true ?
                                   true
                                   : false
                              }
                              readOnly={

                                state.NumberCounts.Editable == 1 &&
                                check == true
                                  ? true
                                  :check != true && state.ClientBranchIDs.SUBROLE == 3 ?
                                  false :
                                  check == true ?
                                   true
                                   : false                              }
                              onChange={(e) => {
                                HandleChanges(e);
                                setcityerr("");
                              }}
                              value={data.city_name}
                            />
                            <p className="Error" style={{ marginLeft: "-5px" }}>
                              {cityErr}
                            </p>
                          </div>
                          <div className="col-sm-3 mt-3">
                            <label for="validationCustom01" class="form-label">
                              State
                            </label>
                            <span style={{ color: "red" }}>*</span>


                            <Select
                              className="Selects stateNames"
                              styles={{ position: "relative", top: "60px" }}
                              onSelect={(e) => setMuliselect(e)}
                              onChange={(e) => {
                                handleSelectChange(e);
                                setstateerr("");
                              }}
                              onInputChange={handleInputChange}
                              options={nameList}
                              labelledBy="Select"
                              value={PresenStaVal}
                              isDisabled={

                                state.NumberCounts.Editable == 1 &&
                                check == true
                                  ? true
                                  :check != true && state.ClientBranchIDs.SUBROLE == 3 ?
                                  false :
                                  check == true ?
                                   true
                                   : false
                              }
                            />
                            {/* <p className="Error">{stateerror}</p> */}
                            <p className="Error" style={{ marginLeft: "-5px" }}>
                              {stateErr}
                            </p>
                          </div>
</div>
                          <div className="row PINCODE" style={{marginTop:"15px"}}>


                          <div className="col-md-3 mt-5">
                            <label for="validationCustom01" class="form-label">
                              Pincode 
                            </label>
                            <span style={{ color: "red" }}>*</span>

                            <input
                              type="number"
                              class="form-control"
                              id="validationCustom01"
                              autocomplete="off"
                              name="pin_code"
                              ref={inputRef}
                              readOnly={
                                state.NumberCounts.Editable == 1 &&
                                check == true
                                  ? true
                                  :check != true && state.ClientBranchIDs.SUBROLE == 3 ?
                                  false :
                                  check == true ?
                                   true
                                   : false
                              }
                              step="1"
                              onKeyDown={preventZoom}  // Prevent zoom and unwanted keys
                              onPaste={handlePaste}    // Handle pasting
                              onWheel={preventZoom}    // Prevent zooming with the mouse wheel


                              
                              onChange={(e) => {
                                const value = e.target.value;
                          
                                const phoneRegex = /^[1-9][0-9]{0,6}$/;
                                setpinerr("");
                                if (value.length <= 6 && (phoneRegex.test(value) || value === '')) {
                                  HandleChanges(e);
                                }
                              }}
                              value={
                                data.pin_code
                                // ? data.pin_code.slice(0, 6)
                                // : data.pin_code
                              }
                              disabled={
                                state.NumberCounts.Editable == 1 &&
                                check == true
                                  ? true
                                  :check != true && state.ClientBranchIDs.SUBROLE == 3 ?
                                  false :
                                  check == true ?
                                   true
                                   : false
                              }
                            />
                            <p className="Error" style={{ marginLeft: "-5px" }}>
                              {pinErr}
                            </p>
                          </div>
                        </div>
                      

                      </div>
                      {
                       (state.NumberCounts.Editable == 2 || state.ClientBranchIDs.SUBROLE == 3) && (state.NumberCounts.EmployeeFormFIll == true)

                       ? (
                        <div
                          className="RoleButton"
                          style={{
                            display: "flex",
                            gap: "15px",
                            justifyContent: "flex-end",
                            padding: "0px 15px",
                            marginBottom: "20px",

                            alignItems: "center",
                          }}
                        >
                          <button
                            class="btn ButtonCSS"
                            style={{ color: "#ffff", background: "#234492" }}
                            onClick={(e) => {
                              dispatch(SetActiveTabs(1));
                            }}
                          >
                            Previous
                          </button>

                          <button
                            class="btn ButtonCSS"
                            style={{ color: "#ffff", background: "#234492" }}
                            onClick={(e) => {
                              HandleNext(e);
                            }}
                          >
                            Save & Continue
                          </button>
                        </div>
                      ) : 
                      
<>

{                       state.NumberCounts.Editable == 1 &&
                                            state.SideBarFiles.UserEmailID  == "admin@gmail.com" || state.SideBarFiles.UserEmailID  == "admin@qpms.in"  ? 


                        <div
                          className="RoleButton"
                          style={{
                            display: "flex",
                            gap: "15px",
                            justifyContent: "flex-end",
                            padding: "0px 15px",
                            marginBottom: "20px",

                            alignItems: "center",
                          }}
                        >
                          <button
                            class="btn ButtonCSS"
                            style={{ color: "#ffff", background: "#234492" }}
                            onClick={(e) => {
                              dispatch(SetActiveTabs(1));
                            }}
                          >
                            Previous
                          </button>

                          <button
                            class="btn ButtonCSS"
                            style={{ color: "#ffff", background: "#234492" }}
                            onClick={(e) => {
                              HandleNext(e);
                            }}
                          >
                            Save & Continue
                          </button>
                        </div>
                        : null}
</>
                      
                      }
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    
      {CroppImageView && (
        <ImageCropper
          updateAvatar={updateAvatar}
          // selectedImage={profileFiles}
                    selectedImage={CroppImageViewCount == 1 ? aadhaarFiles :profileFiles}

          getCroppedImg={getCroppedImg}
          closeModal={() =>setCroppImageView(false)}
        />
      )}

    </>
  );
};

export default AddressForm;
